import { render, staticRenderFns } from "./WebPartFormShopDesigner.vue?vue&type=template&id=6789fcb6&"
import script from "./WebPartFormShopDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6789fcb6')) {
      api.createRecord('6789fcb6', component.options)
    } else {
      api.reload('6789fcb6', component.options)
    }
    module.hot.accept("./WebPartFormShopDesigner.vue?vue&type=template&id=6789fcb6&", function () {
      api.rerender('6789fcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormShopDesigner.vue"
export default component.exports